import * as React from 'react';

import { Panel, PanelProps } from 'src/components/panelStack/PanelStack';
import { PanelStackDrawer } from 'src/components/resourceDialog/PanelStackDrawer';
import {
  ProjectVirtualGraphPreviewDialogContext,
  useProjectVirtualGraphPreviewDialogContextValue,
} from 'src/containers/ProjectVirtualGraphPreviewDialog/context/useProjectVirtualGraphPreviewDialog';
import { VirtualGraphOverviewPanel } from 'src/containers/ProjectVirtualGraphPreviewDialog/panels/VirtualGraphOverviewPanel';
import { ProjectVirtualGraphPreviewDialogFooter } from 'src/containers/ProjectVirtualGraphPreviewDialog/ProjectVirtualGraphPreviewDialogFooter';
import { uiSlice } from 'src/store/ui/ui.slice';
import { useReduxDispatch } from 'src/utils/hooks/useReduxDispatch';
import { useReduxSelector } from 'src/utils/hooks/useReduxSelector';

export const ProjectVirtualGraphPreviewDialog: React.VFC = () => {
  const dispatch = useReduxDispatch();
  const contextValue = useProjectVirtualGraphPreviewDialogContextValue();

  const { isOpen } = useReduxSelector(
    (state) => state.ui.virtualGraphPreviewDialog
  );

  const initialPanel: Panel<object> = React.useMemo(() => {
    return {
      renderPanel: VirtualGraphOverviewPanel as (
        props: PanelProps<object>
      ) => React.ReactElement | null,
      props: {},
    };
  }, []);

  const handleClose = () => {
    contextValue.resetLocalState();
    dispatch(
      uiSlice.actions.toggledVirtualGraphPreviewDialog({ isOpen: false })
    );
  };

  const hasFooterOptions = Boolean(
    contextValue.footerOptions.onBack ||
      contextValue.footerOptions.onNext ||
      contextValue.footerOptions.onCancel ||
      contextValue.footerOptions.onSave
  );

  return (
    <PanelStackDrawer
      ContextProvider={ProjectVirtualGraphPreviewDialogContext.Provider}
      contextValue={contextValue}
      FooterComponent={ProjectVirtualGraphPreviewDialogFooter}
      fullSize={contextValue.fullSize}
      hasFooterOptions={hasFooterOptions}
      headerBackButton={contextValue.headerBackButton}
      initialPanel={initialPanel}
      isOpen={isOpen}
      onClose={handleClose}
      title={contextValue.dialogTitle}
    />
  );
};
